import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameModel, GameObstacleTypeEnum, RoadObjectType } from '../../../../Models/GameModel';
import { AnimationContents } from '../../../../../AnimationContents';
import { GameLogic } from '../../../../Logic/GameLogic';
import { remapValue } from '../../../../Common/Utils';
import { GameObstacleProjectionController } from './GameObstacleProjectionController';
import { Random } from '../../../../Utils/Math';
import { VFXController } from '../VFX';
import { VFXMoney } from '../VFXMoney';
import { ColliderController } from '../Collider';
import { SpineContainer } from '../../../Common/SpineContainer';
import { SpineConst } from '../../../../Constants/SpineConst';

export interface IGameObstacleControllerOptions {
    type: GameObstacleTypeEnum;
    projectionController: GameObstacleProjectionController;
}


export class GameObstacleController extends AnimationBaseController {
    $model: GameModel;
    public destroyed: boolean = false;
    public _projectionScale: number[] = [0.2, 6.5];

    public _type: GameObstacleTypeEnum = GameObstacleTypeEnum.none;
    public _projectionController: GameObstacleProjectionController;
    public spine: SpineContainer;
    
    private collider: ColliderController;

    public constructor(
        @Inject public options: IGameObstacleControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('GameObstacleController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'obstacle',
        };
    }

    protected onInitialize(): void {
        this.collider = this.addChildController(
            {
                controller: ColliderController,
            }, 
            "collider"
        ) as ColliderController;
        this._type = this.options.type;
        this._projectionController = this.options.projectionController;
        this.display.name = 'obstacle';

        this.visible = false;

        this.reskinObstacle();
        this.display["controller"] = this;
        this.display.getBounds = this.collider.display.getBounds.bind(this.collider.display);

        if (this.options.type == GameObstacleTypeEnum.horse){
            this.spine = new SpineContainer(this.$model, ["unicon_idle","unicon_collectable"], SpineConst.horse);
            this.gotoAndStop(-1);
            this.display.addChild(this.spine.container);
            this.spine.setAnimation("unicon_idle", true);
            this.spine.container.scale.set(-1.5,1.5);
            this.spine.container.y = -this.spine.container.height /2.4;
            
        }
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    protected onUpdate(frameRate: number) {
        // if(!this._projectionController) return;
        // const globalProjectionPoint = this._projectionController.display.parent.toGlobal(this._projectionController.display.position);
        // const localPoint = this.display.parent.toLocal(globalProjectionPoint, this.renderer.stage);

        // let scale = remapValue(globalProjectionPoint.y,
        //     this.renderer.renderer.height * 0.25, this.renderer.renderer.height,
        //     this._projectionScale[0] * GameModel.SCALE, this._projectionScale[1] * GameModel.SCALE,
        // );

        // if ((this._type === GameObstacleTypeEnum.horse)) {
        //     scale = scale * (this._projectionController.getRoadIndex() < 0 ? 1 : -1);
        // }

        // this.display.x = localPoint.x;
        // this.display.y = localPoint.y;
        // this.display.scale.set(scale, Math.abs(scale));
        
    }

    public setAnim(name: string) {
        this.gotoAndStop(name);
    }

    public getType(): GameObstacleTypeEnum {
        return this._type;
    }

    public getObjectType(): RoadObjectType {
        return RoadObjectType.obstacle;
    }

    public getIndex(): number {
        return this._projectionController.getIndex();
    }

    public getRoadIndex(): number {
        return this._projectionController.getRoadIndex();
    }

    public getProjectionController(): GameObstacleProjectionController {
        return this._projectionController;
    }

    public reskinObstacle() {
        this.collider.gotoAndStop(this._type);
        // this.display.children.forEach(child=>{
        //     child.visible = true;
        //     child.renderable = true;
        // })
        switch (this._type) {
            case GameObstacleTypeEnum.hotel:
            case GameObstacleTypeEnum.flora:
            case GameObstacleTypeEnum.roadSign:
                this.gotoAndStop(this._type + '_level_' + this.$model.currentLevel);
                break;
            default:
                this.gotoAndStop(this._type);
        }

        //additional logic
        switch (this._type) {
            case GameObstacleTypeEnum.hole:
                this.gotoAndStopByQuery('hole', this.$model.currentLevel - 1);
                break;
            case GameObstacleTypeEnum.hotel:
                this.gotoAndStopByQuery('hotel', Math.round(Random() * 35));
                break;
            case GameObstacleTypeEnum.flora:
                switch (this.$model.currentLevel) {
                    case 1:
                        this.gotoAndStopByQuery('flora_level_' + this.$model.currentLevel, Math.round(Random() * 2));
                        break;
                    case 2:
                        this.gotoAndStopByQuery('flora_level_' + this.$model.currentLevel, Math.round(Random() * 5));
                        break;
                }

                break;
        }

        // this.display.children.forEach(child=>{
        //     if(!child.visible){
        //         this.display.removeChild(child);
        //     }
        // });
    }

    public boom(cb: () => void) {
        if (this.destroyed) return;

        // this.display.children.forEach(c=>c.visible = false);

        this.destroyed = true;
        // const vfx = new VFXController(this.$model);
        const moneyVfx = new VFXMoney(this.$model, ["ffx"], SpineConst.VFXUMoney);
        this.spine.setAnimation("unicon_collectable", false);
        // this.display.addChild(vfx.container);
        this.display.addChild(moneyVfx.container);
        let counter = 0;
        // vfx.spine.state.addListener({
        //     complete: track => () => {
        //         // console.log("call callback");
        //         cb();
        //     }
        // });
        // vfx.setAnimation("fx_explosion", false);

    }
}
